import {RAMUser, Contact, Bank, BankDetails} from "./";
import {Owner} from "./owner";

export class MerchantData {
    constructor(businessData) {
        this.opportunity_external_id = '';
        this.reseller_external_id = '';
        this.application_external_id = '';
        this.sales_owner_user_external_id = '';
        this.merchant_owner_user_external_id = '';
        this.creator_user_external_id = '';
        this.merchant_control = '';
        //About Business
        this.section = '';
        this.save_change = '';
        this.legal_name = '';  // legal name
        this.trade_name = '';  //trading Name of Business
        this.assoc_name = '';  //association Name
        this.ownership_entity_type = '';  //type of business
        this.reg_number = '';  //company registration number
        this.government_owned_entity = '0';  //Government Owned Entity

        this.foreign_entity = '';  //Foreign Entity?
        this.irs_status = '';  //IRS Status
        this.irs_filing_name = '';  //IRS Filing Name
        this.tin_type = '';  //Tin Type
        this.business_tin_ssn_number = '';  //TIN Number  SSN Number

        this.int_tax_exempt_flag = '';  //VAT Registered?
        this.other_tax_decision = '';
        this.tax_options = '';
        this.vat_applied_flag = '';  //VAT Applied For?
        this.tax_id = '';   // Registered VAT Number
        this.int_tax_id = '';  // is tax_id == int_tax_id?
        this.current_acquirer = '';  //Do you have a current acquirer?
        this.previous_proc_name = '';  //Previous Acquirer Name

        this.proc_change_reason = '';  //Change Reason
        this.mcc_iso = '';  //MCC
        this.business_category = '';  //Business Category
        this.tenant_parent_mid_id = '';  //Parent MID
        this.foundation_date = '';  //Business Started

        this.incorporated_date = '';  //Incorporated Date
        this.year_incorporated = '';  //Year Incorporated
        this.incorp_state = '';  //State of Incorporation
        this.business_time_zone = '';  //Business Time Zone

        //turnover
        this.annual_turnover = '500000';  //Total Annual Turnover
        this.avg_tran_value = '50';  //Total Annual Turnover
        this.turnover_bus_to_bus_perc = '';  //Turnover Business to Business Payments
        this.turnover_bus_to_cons_perc = '';  //Turnover Business to Consumer Payments
        this.annual_card_turnover = '200000'; //Combined Annual Card Sales
        this.card_bus_to_bus_perc = '';  //Card Business to Business Payments
        this.card_bus_to_cons_perc = '';  //Card Business to Consumer Payments
        this.business_average_ticket_sales_amt = '';  //Average Transaction Value
        this.business_highest_ticket_sales_amt = '';  //Highest Transaction Value

        //Registered Address
        this.zip_code = '';  //Postcode
        this.street_number = '';
        this.floor = '';
        this.suite_apart_number = '';  //Suite/Apartment Number
        this.house_name = '';  //Building Name
        this.house_number = '';  //Building Number
        this.street_line_1 = '';
        this.locality = '';
        this.city = '';
        this.county_code = '';  //County/State
        this.province = '';
        this.country_code = '';  //Country

        //Additional Information
        this.additional_trading_information = '';  //Additional Trading Information

        //intermediary Owners
        this.has_intermediary_owner = '';
        this.additional_intermediary_owners = [];

        //Application Options
        this.billing_level = '';
        this.pricing_level = '';  //Is Pricing Same for all Outlets?
        this.welcome_pack = '';  //Does the merchant wish to receive Welcome Packs/Letters?
        this.mail_statement_to = '';
        this.ent_reporting_required = '';  //Reporting Required?
        this.ent_service_contract_id = '';

//
        this.new_to_card_payments = '';
        this.gdpr_agreement = '';
        this.has_merchant_confirmed_gdpr = '';

        this.rm_id = '';
        this.ownership_entity_id = '';
        this.reg_charity_number = '';
        this.date_incorporated = '';
        this.bank_rthsip = '';
        this.get_bank_details_from_merchant = '';
        this.current_acquirer_flag = '';
        this.reporting_required = '';
        this.ram_users = [new RAMUser()];
        this.registration_address = new Contact();
        this.crud_business_entity_id = '';
        this.status_code = '';
        this.name = '';
        this.registration_country = '';
        this.products_services_sold = '';
        this.bussiness_registration_number = '';
        this.merchant_language = '';
        this.business_entity_status = '';
        this.ecommerce_flag = '';
        this.moto_flag = '';
        this.deposits_flag = '';
        this.recurring_flag = '';
        this.tranarmor_token_data = '';
        this.annual_credit_turnover = '';
        this.annual_debit_turnover = '';
        this.annual_alt_pmnt_turnover = '';
        this.moto_sales_perc_age = '';
        this.irs_filing_name = '';
        this.business_tin_ssn_number = '';
        this.reg_charity_number = '';
        this.vat_number = '';
        this.ftf_sales_perc_age = '';
        this.ecom_sales_perc_age = '';
        this.ecom_alt_pmnt_sales_perc_age = '';
        this.delivery_0_days_perc = '';
        this.delivery_1_to_7_days_perc = '';
        this.delivery_8_to_14_days_perc = '';
        this.delivery_15_to_30_days_perc = '';
        this.delivery_over_30_days_perc = '';
        this.refund_policy = '';
        this.refund_days = '';
        this.site_visit_date = '';
        this.sales_contract_date = '';
        this.introduction_date = '';
        this.contract_date = '';
        this.facility_required_date = '';
        this.application_rec_date = '';
        this.boarding_platform = '';
        this.signatories_upload_documents_flag = '0';
        this.documents = [];
        this.owners = [new Owner];
        this.banks = [new BankDetails];
        if (!!businessData) {
            this.setBusinessData(businessData);
        }
    }

    setBusinessData(businessData) {
        let business_data_keys = Object.keys(businessData);
        business_data_keys.map(f => {
            if(f === 'registration_address') {
                this[f] = !!businessData[f] ? new Contact(businessData[f]) : new Contact();
            } else if( f === 'owners'){
                this[f] = !!businessData[f] ? businessData[f].map( obj => new Owner(obj)) : [new Owner];
            }else if( f === 'banks'){
                this[f] = !!businessData[f] ? businessData[f].map(obj =>  new BankDetails(obj)) : [new BankDetails];
            }else {
                this[f] = !!businessData[f] ? businessData[f] : '';
            }
        });
    }
}